// Module
var code = "<div class=\"c-stateIndicator\">\n    <div ng-class=\"$ctrl.stateClass\">\n        <inv-icon ng-if=\"$ctrl.stateGlyph\" class=\"c-stateIndicator-icon\" glyph=\"$ctrl.stateGlyph\">\n        </inv-icon>\n        <div ng-bind=\"$ctrl.stateTitle\" class=\"c-stateIndicator-title\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;